import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Lock } from "lucide-react";

/** Returns true if the currently logged-in user has read-only access to
 * configuration pages (rule-sets, lookups, cleanups, regex, transforms,
 * file templates). Backend already enforces this — this hook hides write
 * controls so dept_user doesn't see buttons that 403 on click. */
export function useReadOnly() {
  const { user } = useAuth();
  return user?.role === "dept_user";
}

/** A slim yellow banner rendered at the top of every read-only page. */
export function ReadOnlyBanner({ what = "this page" }) {
  const ro = useReadOnly();
  if (!ro) return null;
  return (
    <div data-testid="readonly-banner" style={{
      display: "flex", alignItems: "center", gap: "0.55rem",
      padding: "0.55rem 0.9rem", marginBottom: "1rem",
      background: "#FEF3C7", border: "1px solid #F59E0B",
      color: "#78350F", borderRadius: 8, fontSize: "0.82rem",
    }}>
      <Lock size={14} />
      <span><strong>Read-only.</strong> Your role (<code>dept_user</code>) can view {what} but can't create, edit, or delete them. Ask a <code>dept_admin</code> or <code>superadmin</code> to make changes.</span>
    </div>
  );
}
